import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./VotingResultsList.module.css";
import DiamondProxyVoteItem from "../DiamondProxyVoteItem";
import DiamondVoteResultItem from "../DiamondVoteResultItem";
import DiamondMultipleChoiceResultItem from "../DiamondMultipleChoiceResultItem";
import Button from "shared/Button";
import MultipleChoiceProxyVoteItem from "../MultipleChoiceProxyVoteItem";

/**
 * Interactive component that displays Voting Results List.
 */

export function VotingResultsList({
  diamonds,
  multipleChoiceItems,
  onSubmit,
  readOnly,
  isHideInfo,
}) {
  const [proxyVoteView, setProxyVoteView] = useState(false);
  const [mcVotes, setMCVotes] = useState(multipleChoiceItems ? diamonds : null);
  const [_diamonds, setDiamonds] = useState(diamonds);
  const [updateArray, setUpdateArray] = useState([]);
  console.log(diamonds);
  useEffect(() => {
    setDiamonds(diamonds);
  }, [diamonds]);

  useEffect(() => {
    if (multipleChoiceItems) {
      setMCVotes(diamonds);
    }
  }, [_diamonds, multipleChoiceItems]);

  const handleSelection = (diamond, e) => {
    var fullChoice = multipleChoiceItems
      .filter((i) => e.includes(i.itemPosition))
      .map((i) => i.itemTitle);

    var updateList = mcVotes.map((t) => {
      if (t.id === diamond.id && e.length > 0) {
        return {
          ...t,
          selections: fullChoice,
          isProxyVote: true,
          votingStatus: "Multiple Choice",
        };
      }
      return t;
    });
    setMCVotes(updateList);

    let updates = [...updateArray];
    let diamondInfo = updateList.find((a) => a.id === diamond.id);
    let update = updates.find((a) => a.id === diamond.id);
    if (!update) {
      updates.push(diamondInfo);
    } else {
      update.votingStatus = diamondInfo.votingStatus;
      update.isProxyVote = diamondInfo.isProxyVote;
      update.selections = diamondInfo.selections;
    }

    setUpdateArray(updates);
  };

  const proxyVoteList = _diamonds
    .filter(
      (diamond) =>
        diamond.votingStatus === "Pending" || diamond.isProxyVote === true
    )
    .map((diamond) => ({ ...diamond }));

  const multipleChoiceProxyVoteList = _diamonds
    .filter(
      (diamond) =>
        diamond.selections === undefined ||
        diamond.selections.length === 0 ||
        diamond.isProxyVote === true
    )
    .map((diamond) => ({ ...diamond }));

  const handleProxyVote = (diamondInfo, value) => {
    diamondInfo.votingStatus = value;
    if (diamondInfo.votingStatus === "Pending") {
      diamondInfo.isProxyVote = false;
    } else {
      diamondInfo.isProxyVote = true;
    }

    let updates = [...updateArray];
    let update = updates.find((a) => a.id === diamondInfo.id);
    if (!update) {
      updates.push(diamondInfo);
    } else {
      update.votingStatus = diamondInfo.votingStatus;
      update.isProxyVote = diamondInfo.isProxyVote;
    }

    setUpdateArray(updates);
  };

  const submitProxyVote = (updateArray) => {
    for (const obj of updateArray) {
      _diamonds.map((diamond) => {
        if (diamond.id === obj.id) {
          diamond.selections = [obj.votingStatus.toUpperCase()];
          diamond.votingStatus = obj.votingStatus;
          diamond.isProxyVote = obj.isProxyVote;
        }
      });
    }
    setUpdateArray([]);
    onSubmit(_diamonds);
    setDiamonds(_diamonds);
  };

  const submitMultipleChoiceProxyVote = () => {
    for (const obj of updateArray) {
      _diamonds.map((diamond) => {
        if (diamond.id === obj.id) {
          diamond.selections = [obj.votingStatus.toUpperCase()];
          diamond.votingStatus = obj.votingStatus;
          diamond.isProxyVote = obj.isProxyVote;
          diamond.selections = obj.selections;
        }
      });
    }
    setUpdateArray([]);
    onSubmit(_diamonds);
    setMCVotes(_diamonds);
    setDiamonds(_diamonds);
  };

  return (
    <div>
      {/* TODO: only display EC in EC recommendation */}
      {proxyVoteView === false ? (
        <div className={styles.title}>
          {/* <div className={styles.sectionTitle}>
            Executive Committee (
            {_diamonds.filter((diamond) => diamond.role === "EC").length})
          </div> */}
          <div className={styles.sectionTitle}>
            Voting Members (
            {_diamonds.filter((diamond) => diamond.role === "MT1").length})
          </div>
          <div style={{ visibility: !readOnly ? "visible" : "hidden" }}>
            <Button
              visible={!readOnly}
              children="Proxy Vote"
              className={classNames(styles.proxyButton)}
              onClick={() => setProxyVoteView(true)}
            />
          </div>
        </div>
      ) : (
        <div className={styles.title}>
          <div className={styles.sectionTitle}>
            Hasn't Voted ({proxyVoteList.length})
          </div>
          <div className={styles.proxyVoteButtonContainer}>
            <Button
              children="Cancel"
              className={classNames(styles.cancelButton)}
              onClick={() => setProxyVoteView(false)}
            />
            {multipleChoiceItems === undefined ? (
              <Button
                children="Submit Vote"
                className={classNames(styles.submitVoteButton)}
                onClick={() => {
                  submitProxyVote(updateArray);
                  setProxyVoteView(false);
                }}
              />
            ) : (
              <Button
                children="Submit Vote"
                className={classNames(styles.submitVoteButton)}
                onClick={() => {
                  submitMultipleChoiceProxyVote();
                  setProxyVoteView(false);
                }}
              />
            )}
          </div>
        </div>
      )}

      {proxyVoteView === false ? (
        <div>
          {/* <div className={styles.listRow}>
            {_diamonds
              .filter((diamond) => diamond.role === "EC")
              .map((diamond) => {
                return multipleChoiceItems === undefined ? (
                  <div className={styles.resultItem}>
                    <DiamondVoteResultItem diamondInfo={diamond} />
                  </div>
                ) : (
                  <div className={styles.resultItem}>
                    <DiamondMultipleChoiceResultItem diamondInfo={diamond} />
                  </div>
                );
              })}
          </div> */}
          {/* <div className={styles.sectionTitle}>
            Voting Members (
            {_diamonds.filter((diamond) => diamond.role === "MT1").length})
          </div> */}
          <div className={styles.listRow}>
            {_diamonds
              .filter((diamond) => diamond.role === "MT1")
              .map((diamond) => {
                return multipleChoiceItems === undefined ? (
                  <div className={styles.resultItem}>
                    <DiamondVoteResultItem
                      diamondInfo={diamond}
                      isHideInfo={isHideInfo}
                    />
                  </div>
                ) : (
                  <div className={styles.resultItem}>
                    <DiamondMultipleChoiceResultItem
                      diamondInfo={diamond}
                      isHideInfo={isHideInfo}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      ) : (
        <div className={styles.listRow}>
          {multipleChoiceItems === undefined
            ? proxyVoteList.map((diamond) => {
                return (
                  <div className={styles.proxyItem}>
                    <DiamondProxyVoteItem
                      diamondInfo={diamond}
                      handleProxyVote={handleProxyVote}
                      isHideInfo={isHideInfo}
                    />
                  </div>
                );
              })
            : multipleChoiceProxyVoteList.map((diamond) => {
                return (
                  <div className={styles.mcProxyItem}>
                    <MultipleChoiceProxyVoteItem
                      diamondInfo={diamond}
                      multipleChoiceItems={multipleChoiceItems}
                      setSelected={(e) => handleSelection(diamond, e)}
                      selected={multipleChoiceItems
                        .filter((i) => diamond.selections.includes(i.itemTitle))
                        .map((i) => i.itemPosition)}
                      isHideInfo={isHideInfo}
                    />
                  </div>
                );
              })}
        </div>
      )}
    </div>
  );
}

VotingResultsList.propTypes = {
  // Array of object with info about the diamond ( firstName-String, lastName-String, photo-String, checkedIn-Bool, votingStatus-string, isProxyVote-Bool)
  diamonds: PropTypes.array,

  // Array of the multiple choice items
  multipleChoiceItems: PropTypes.array,

  // Function to handle submission
  onSubmit: PropTypes.func,
};

VotingResultsList.defaultProps = {
  diamonds: [],
  onSubmit: (e) => console.log(e),
};
